import styledAx from "styled-ax";
import theme from "./theme";

const ax = styledAx(theme);

export default ax;
